<template>
    <div id="genertateExcelButtons">
        <div id="spreadsheet_loader_wrapper"  :class="[spreadsheetGenerating ? 'appear' : '']" v-show="spreadsheetGenerating">
            <div id="spreadsheet_loader" :class="[spreadsheetGenerating ? 'appear' : '']"></div>
        </div>

        <div id="spreadsheetButton" class="generateSpreadsheetButton" v-if="!$store.getters.isMobile" @click="openSpreadsheetForm" :class="[spreadsheetGenerating ? 'generating' : '']">
            TOP 250 SHOPPING LIST
        </div>
        <div id="spreadsheetButton" class="generateSpreadsheetButton" v-else @click="openSpreadsheetForm" :class="[spreadsheetGenerating ? 'generating' : '']">
            <img id="excelIcon" src="@/assets/excelWhite.png"/>
        </div>
        
        <admin-spreadsheet v-show="$store.getters.isSpreadsheetFormVisible"/>
    </div>
</template>

<script>
    import AdminSpreadsheet from './SpreadsheetForm.vue';

    export default {
        data() {
            return{}
        },
        components: {
            'admin-spreadsheet': AdminSpreadsheet
        },
        computed: {
            spreadsheetGenerating() {
                return this.$store.getters.isSpreadsheetGenerating;
            }
        },
        mounted() {
            document.addEventListener('click', this.handleClickOutside);
        },
        unmounted() {
            document.removeEventListener('click', this.handleClickOutside)
        },
        methods: {
            openSpreadsheetForm() {
                let eventLabel = this.$store.getters.isMobile ? 'mobile' : 'pc';
                this.$gtag.event('open', {'event_category': 'spreadsheet_form','event_label': eventLabel});
                this.$store.commit('updateOpenSpreadsheetForm', true);
            },
            handleClickOutside(evt) {
                if (!this.$el.contains(evt.target)) {
                    if(this.$store.getters.isSpreadsheetFormVisible) {
                        this.closeSpreadsheetForm();
                    }
                }
            },
            closeSpreadsheetForm() {
                this.$store.commit('updateOpenSpreadsheetForm', false);
            }
        }
    }
</script>

<style>
    #genertateExcelButtons {
        position: absolute;
        width: calc(22 * var(--vw));
        display: flex;
        justify-content: center;
        bottom: calc(89 * var(--vh));
        left: calc((10 * var(--vw)) + (1 * var(--vh)));
    }

    .inmobile #genertateExcelButtons {
        width: calc(4 * var(--vh));
        left: calc(1 * var(--vh));
        justify-content: flex-start;
    }

    .generateSpreadsheetButton {
        background-color: var(--mccluskeyBlue); /*#0077C0;*//*#0079B6;*//*#3378b1;*//* #AF873F;*/
        border-radius: calc(var(--vratio) * var(--vh)); /*5px;*/
        width: calc(12 * var(--vw));
        height: calc(1.7 * var(--vh));
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: "myriad-pro", arial, sans-serif;
        font-weight: bold;
        color: white;
        font-size: calc((.8 * var(--vw)) + ((var(--vratio) - .5) * 1em));/*calc(.8 * var(--vw));*/ /*2.1vh; */
        padding: calc(.9 * var(--vh)) calc(.9 * var(--vw));
        white-space: nowrap;
        border: solid white .75px;
    }

    .inmobile .generateSpreadsheetButton {
        background-color: transparent;
        height: calc(3 * var(--vh));
        width: calc(3 * var(--vh));
        bottom: calc(1 * var(--vh)); 
        padding: calc(1 * var(--vh)) calc(.5 * var(--vh));
        font-size: calc(2.1 * var(--vh));
        border: none;
        border-radius: 5px;
    }

    #excelIcon {
        height: inherit;
        width: inherit;
    }

    .generateSpreadsheetButton.generating {
        color: var(--mccluskeyGold); /*#AF873F;*/
    }

    .generateSpreadsheetButton:hover {
        color: black;/*#2c3e50;*/
        border-color: var(--mccluskeyGold); /*#AF873F;*/
    }

    #spreadsheet_loader_wrapper {
        position: absolute;
        height: calc(4.5 * var(--vh));
        width: calc(17.25 * var(--vw));
        background-color: black;
        z-index: 1;
        opacity: 0;
        transition: opacity 1s;
    }

    #spreadsheet_loader_wrapper.appear {
        opacity: .4;
    }

    #spreadsheet_loader {
        position: absolute;
        left: calc((8.125 * var(--vw)));
        top: calc((2.5 * var(--vh)) - 1.25px);
        z-index: 2;
        margin: -15px 0 0 -15px;
        border: 6px solid rgb(172,179,183);
        border-radius: 50%;
        border-top: 6px solid var(--mccluskeyBlue); /*#207BD3;*/
        width: 18px;
        height: 18px;
        -webkit-animation: spin 3s linear infinite;
        animation: spin 3s linear infinite;
        opacity: 0;
        -webkit-transition: opacity 1s;
        -moz-transition: opacity 1s;     
        transition: opacity 1s;
    }

    #spreadsheet_loader.appear {
        opacity: 1;
    }
    
    @-webkit-keyframes spin {
        0% { -webkit-transform: rotate(0deg); }
        100% { -webkit-transform: rotate(360deg); }
    }
    
    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
</style>